// utils/tagUtils.ts
export const compareTags = (oldTags: string[], newTags: string[]) => {
    const oldSet = new Set(oldTags);
    const newSet = new Set(newTags);
    
    const existing = oldTags.filter(tag => newSet.has(tag));
    const added = newTags.filter(tag => !oldSet.has(tag));
    const removed = oldTags.filter(tag => !newSet.has(tag));
    
    return { existing, added, removed };
};